/**
 * @generated SignedSource<<7bcf59438564dc08ede8c64a5a35656d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLOnboardingTaskId = "CHAT_WITH_TIERZERO" | "CONNECT_CODE" | "CONNECT_DOCUMENTATION" | "CONNECT_MESSAGING" | "CONNECT_ONCALL" | "CONNECT_TELEMETRY" | "CREATE_AND_RUN_FIRST_DIGEST" | "CREATE_FIRST_ALERT_RESPONDER" | "INSPECT_INTEGRATION_RESOURCES" | "INTEGRATION_SETUP" | "KNOWLEDGE_SETUP" | "LEARN_ALERT_RESPONDER" | "LEARN_CHAT" | "LEARN_DIGEST" | "MANAGE_MEMORY" | "SETUP_INTEGRATIONS" | "SETUP_TEAM" | "TIERZERO_MD_SETUP" | "TIERZERO_USER_GUIDE" | "%future added value";
export type GraphQLOnboardingTaskStatusEnum = "COMPLETED" | "PENDING" | "TODO" | "TO_REVIEW" | "%future added value";
export type UpdateOnboardingTaskStatusInput = {
  id: any;
  status: GraphQLOnboardingTaskStatusEnum;
};
export type UpdateOnboardingTaskStatusMutation$variables = {
  input: UpdateOnboardingTaskStatusInput;
};
export type UpdateOnboardingTaskStatusMutation$data = {
  readonly updateOnboardingTaskStatus: {
    readonly taskStatus: {
      readonly completedAt: any | null | undefined;
      readonly completedByUser: {
        readonly firstName: string;
        readonly id: any;
        readonly lastName: string;
      } | null | undefined;
      readonly id: any;
      readonly status: GraphQLOnboardingTaskStatusEnum;
      readonly taskId: GraphQLOnboardingTaskId;
    };
  };
};
export type UpdateOnboardingTaskStatusMutation = {
  response: UpdateOnboardingTaskStatusMutation$data;
  variables: UpdateOnboardingTaskStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOnboardingTaskStatusPayload",
    "kind": "LinkedField",
    "name": "updateOnboardingTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLOnboardingTaskStatus",
        "kind": "LinkedField",
        "name": "taskStatus",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUser",
            "kind": "LinkedField",
            "name": "completedByUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateOnboardingTaskStatusMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateOnboardingTaskStatusMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c1ea1a59c62d0173d5f147901ba4f7ad",
    "id": null,
    "metadata": {},
    "name": "UpdateOnboardingTaskStatusMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateOnboardingTaskStatusMutation(\n  $input: UpdateOnboardingTaskStatusInput!\n) {\n  updateOnboardingTaskStatus(input: $input) {\n    taskStatus {\n      id\n      taskId\n      status\n      completedAt\n      completedByUser {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4fd01b897e1574feb00e57bc811a25fe";

export default node;
